import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class ASRRegexAdditionsDeletionsDialog extends Component {
  render() {
    return (
      <Dialog show={this.props.show} width={40} height={40} >
        <DialogHeader caption={'Regex String Confirmation'} closeButton onClose={this.props.onClose} />
        <DialogBody>
          <div className='asr-regex-save-dialog-container'>
            <div className='asr-regex-save-dialog-message-labels'>Do you wish to continue?</div>
            <ul>
              <li className='asr-regex-save-dialog-message-updates'>{this.props.orderIdMessage}</li>
              <li className='asr-regex-save-dialog-message-updates'>{this.props.groupNameMessage}</li>
              <li className='asr-regex-save-dialog-message-updates'>{this.props.asrResultMessage}</li>
              <li className='asr-regex-save-dialog-message-updates'>{this.props.regexStringMessage}</li>
            </ul>
          </div>
        </DialogBody>
        <DialogFooter>
          <span className='asr-dialog-footer'>
            <button
              className='asr-dialog-footer-cancel-button'
              onClick={this.props.onClose}
            >
              Cancel
            </button>
            <button
              className='asr-dialog-footer-save-button'
              onClick={this.props.onSave}
            >
              Confirm
            </button>
          </span>
        </DialogFooter>
      </Dialog>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ASRRegexAdditionsDeletionsDialog ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/asr/components/ASRSaveRegexStringDialog.js